import { render, staticRenderFns } from "./SummaryTable.vue?vue&type=template&id=6b64412d&"
import script from "./SummaryTable.vue?vue&type=script&lang=ts&"
export * from "./SummaryTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VAvatar,VDataTable})
